import React from "react";
import {
  Avatar,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuGroup,
  MenuItem,
  MenuDivider,
  Link,
  useDisclosure,
  Modal,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import ProfileBadge from "./ProfileBadge";
import ResetPassword from "../ResetPassword/ResetPassword";
import { OverlayOne } from "../../util/utility";

const ProfileMenu = ({ name, email, handleLogout }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [overlay, setOverlay] = React.useState(<OverlayOne />);
  return (
    <>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<Avatar name={name} bg="red.50" color="gray.600" />}
          variant="link"
        />
        <MenuList>
          <ProfileBadge name={name} email={email} />
          <MenuGroup title="Profile">
            <MenuItem
              onClick={() => {
                setOverlay(<OverlayOne />);
                onOpen();
              }}
            >
              Change Password
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </MenuGroup>
          <MenuDivider />
          <MenuGroup title="Help">
            <MenuItem>
              <Link href="https://vox.publicissapient.com/home/" isExternal>
                Docs <ExternalLinkIcon mx="2px" />
              </Link>
            </MenuItem>
            <MenuItem>
              <Link href="https://vox.publicissapient.com/home/" isExternal>
                FAQ <ExternalLinkIcon mx="2px" />
              </Link>
            </MenuItem>
          </MenuGroup>
        </MenuList>
      </Menu>

      <Modal
        closeOnOverlayClick={false}
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        {overlay}
        <ResetPassword onClose={onClose} />
      </Modal>
    </>
  );
};

export default ProfileMenu;
